import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="about-hero">
        <span className="about-badge">About Salekiya</span>
        <h1>Connecting Local Buyers & Sellers Seamlessly</h1>
        <p>
          We build simple, fast, and secure local commerce for everyday items in your city and neighborhood.
        </p>
      </div>

      <div className="about-content">
        <div className="about-grid">
          <div className="about-card">
            <div className="card-icon">⚡</div>
            <h3>Fast & Direct Deals</h3>
            <p>
              Connect directly with owners and buyers via built-in real-time chat. Negotiate offers without middlemen.
            </p>
          </div>

          <div className="about-card">
            <div className="card-icon">📍</div>
            <h3>Hyper-Local Discovery</h3>
            <p>
              Find pre-owned electronics, furniture, books, and vehicles right within your locality and city.
            </p>
          </div>

          <div className="about-card">
            <div className="card-icon">🛡️</div>
            <h3>Safe & Verified</h3>
            <p>
              OTP-verified user profiles and transparent product conditions safeguard your buying and selling experience.
            </p>
          </div>
        </div>

        <div className="about-story">
          <h2>Our Mission</h2>
          <p>
            At Salekiya, our goal is to extend the lifecycle of quality goods while offering an effortless local marketplace experience. By making it easy to trade locally, we help communities save money and reduce waste.
          </p>
          <button className="explore-btn" onClick={() => navigate('/')}>
            Explore Products
          </button>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;